import { render, staticRenderFns } from "./AdminBar.vue?vue&type=template&id=15489e3e&scoped=true&"
import script from "./AdminBar.vue?vue&type=script&lang=js&"
export * from "./AdminBar.vue?vue&type=script&lang=js&"
import style0 from "./AdminBar.vue?vue&type=style&index=0&id=15489e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15489e3e",
  null
  
)

export default component.exports